const e = "styles-module__checkbox___SmWI8", _ = "styles-module__checkbox__background___E3xcO", c = "styles-module__checkbox__line___7ghGh", o = "styles-module__checkbox__checkmark___pZF9l", k = {
  checkbox: e,
  "checkbox--disabled": "styles-module__checkbox--disabled___vTQQm",
  "checkbox--selected": "styles-module__checkbox--selected___-qBRs",
  checkbox__background: _,
  "checkbox--indeterminate": "styles-module__checkbox--indeterminate___JC8AQ",
  checkbox__line: c,
  checkbox__checkmark: o,
  "checkbox--error": "styles-module__checkbox--error___xmtyL",
  "checkbox--valid": "styles-module__checkbox--valid___C3F0r"
};
export {
  e as checkbox,
  _ as checkbox__background,
  o as checkbox__checkmark,
  c as checkbox__line,
  k as default
};
